module.exports = __webpack_public_path__ + "img/lbeaute-menu.92aec6d6.png";